var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccessDenied = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.373 177H152C158.627 177 164 171.627 164 165V64.1269C164 60.8319 162.645 57.6819 160.253 55.4157L120.011 17.2888C117.782 15.177 114.828 14 111.757 14H48C41.3726 14 36 19.3726 36 26V128.529",
    stroke: "#1B1B1B",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82H141",
    stroke: "#59BD39",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 100H117",
    stroke: "#59BD39",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 141H89C95.6274 141 101 146.373 101 153V174C101 180.627 95.6274 186 89 186H48C41.3726 186 36 180.627 36 174V150.141",
    stroke: "#1B1B1B",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54 141V136C54 129.373 59.3726 124 66 124H70C76.6274 124 82 129.373 82 136V141",
    stroke: "#1B1B1B",
    strokeWidth: 3
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccessDenied);
export default ForwardRef;